module.exports = __webpack_public_path__ + "static/media/skincarepro_v1_16share_max.990198f7.png";